import { Add, Delete, Link } from '@mui/icons-material';
import {
  Box,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { Dispatch, SetStateAction, useState } from 'react';
import { ILegalTransaction } from '../../Interfaces/ILegalTransaction';
import { AddLegalTransactionsDialog } from './AddLegalTransactionsDialog';
interface IProps {
  legalTransactions: ILegalTransaction[];
  setLegalTransactions: Dispatch<SetStateAction<ILegalTransaction[]>>;
}

export const LegalTransactionsTab = ({
  legalTransactions,
  setLegalTransactions,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onAdd = (legalTransactions: ILegalTransaction[]) => {
    setIsOpen(false);
    setLegalTransactions([...legalTransactions]);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='h5'>Rechtsgeschäfte</Typography>
        <Tooltip title='Rechtsgeschäfte hinzufügen/verwalten'>
          <IconButton onClick={() => setIsOpen(true)}>
            <Add />
          </IconButton>
        </Tooltip>
      </Box>
      <Grid container spacing={2} mt={1}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nr.</TableCell>
              <TableCell>Art</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Bezeichnung</TableCell>
              <TableCell sx={{ width: 150 }}>Aktionen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {legalTransactions.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5}>
                  <i>Keine Rechtsgeschäfte vorhanden.</i>
                </TableCell>
              </TableRow>
            ) : (
              legalTransactions.map((lt, i) => (
                <TableRow key={i}>
                  <TableCell>{lt.idLegalTransaction}</TableCell>
                  <TableCell>{lt.LegalTransactionType}</TableCell>
                  <TableCell>{lt.LegalTransactionState}</TableCell>
                  <TableCell>{lt.Title}</TableCell>
                  <TableCell>
                    <IconButton
                      title='Rechtsgeschäft öffnen'
                      href={`/legaltransaction/${lt.idLegalTransaction}`}
                      target='_blank'
                    >
                      <Link />
                    </IconButton>
                    <IconButton
                      title='Rechtsgeschäft entfernen'
                      onClick={() =>
                        setLegalTransactions(prev =>
                          prev.filter(
                            plt =>
                              plt.idLegalTransaction !== lt.idLegalTransaction
                          )
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Grid>
      {isOpen && (
        <AddLegalTransactionsDialog
          preSelectedLegalTransactions={legalTransactions}
          unmount={() => setIsOpen(false)}
          onAdd={onAdd}
        />
      )}
    </Box>
  );
};
